import React, { Component } from 'react';
import Footer from '../../components/footer/Footer';
import Nav from '../../components/nav/Nav';
import PrivacyInfoUsagePolicyBanner from "../../components/banner/PrivacyInfoUsagePolicyBanner"
import PrivacyInfoUsagePolicyMain from "../../components/main/PrivacyInfoUsagePolicyMain"
class PrivacyInfoUsagePolicy extends Component {
  render() {
    return (
      <div>
        <Nav></Nav>
        <PrivacyInfoUsagePolicyBanner></PrivacyInfoUsagePolicyBanner>
        <PrivacyInfoUsagePolicyMain></PrivacyInfoUsagePolicyMain>
        <Footer></Footer>
      </div>
    )
  }
}

export default PrivacyInfoUsagePolicy
